import { createFileRoute } from "@tanstack/react-router";
import { HelmCompass, HelmLogo } from "@/components/helm-logo";
import { Card, CardContent } from "@/components/ui/card";
import { PendingApproval } from "@/components/pending-approval";

export const Route = createFileRoute("/_auth/pending-approval")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<div className="grid min-h-svh lg:grid-cols-2">
			<div className="bg-primary relative hidden lg:flex flex-col justify-between text-sidebar-foreground p-10">
				<HelmLogo size="small" color="hsl(0 0% 100%)" />

				<div className="space-y-8">
					<div className="space-y-4">
						<h2 className="text-2xl font-semibold text-primary-foreground font-serif">
							Your campaign, simplified
						</h2>
						<p className="text-primary-foreground/80 text-lg leading-relaxed">
							Get a personalized campaign plan, daily priorities, and expert
							guidance—all in one place.
						</p>
					</div>

					<div className="space-y-3">
						<div className="flex items-center gap-3 text-primary-foreground/90">
							<div className="h-2 w-2 rounded-full bg-primary-foreground/60" />
							<span>Daily briefings tailored to your race</span>
						</div>
						<div className="flex items-center gap-3 text-primary-foreground/90">
							<div className="h-2 w-2 rounded-full bg-primary-foreground/60" />
							<span>Fundraising and volunteer management</span>
						</div>
						<div className="flex items-center gap-3 text-primary-foreground/90">
							<div className="h-2 w-2 rounded-full bg-primary-foreground/60" />
							<span>Voter outreach strategy</span>
						</div>
					</div>
				</div>

				<p className="text-primary-foreground/60 text-sm">
					A human system for independent participation in public life
				</p>
			</div>
			<div className="flex flex-col gap-4 p-6 md:p-10">
				<div className="flex justify-center gap-2 md:justify-start">
					<div className="flex items-center gap-2.5 font-medium">
						<HelmCompass size={24} color="hsl(22 82% 31%)" strokeWidth={1.2} />
						<span className="font-display text-sm" style={{ letterSpacing: "0.18em" }}>
							H E L M
						</span>
					</div>
				</div>
				<div className="flex flex-1 items-center justify-center">
					<div className="w-full max-w-md">
						<Card>
							<CardContent className="p-8">
								<PendingApproval />
							</CardContent>
						</Card>
					</div>
				</div>
			</div>
		</div>
	);
}
